/**
 * Created by Mark on 18/04/2017.
 */

import React from 'react';

export default class CardComponent extends React.Component {

    constructor(props){
        super();
        this.props = props;
    }

    render(){
        return <div className={String(this.props.className) + " card-body" + (this.props.noPadding ? " no-padding" : " card-padding")}>{this.props.children}</div>
    }
}



// WEBPACK FOOTER //
// ./src/components/card-body.js